export const getAuthToken = () => {
    const tokens = JSON.parse(localStorage.getItem("tokens")) || JSON.parse(sessionStorage.getItem("tokens")) || null;
    return tokens?.token || null;
};

export const getAuthHeaders = () => {
    const token = getAuthToken();

    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};